/**
 * ThemeContext.jsx
 * Manages dark ("Sapphire Veil") ↔ light ("Amber Mirage") theme toggle.
 * Persists user preference via localStorage key: sdw-theme
 * Applies [data-theme="light"] or [data-theme="dark"] to <html>.
 */

import { createContext, useContext, useEffect, useState } from 'react';

const ThemeContext = createContext({
  theme: 'dark',
  toggleTheme: () => {},
  isDark: true,
});

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => {
    // Initialise from localStorage — default to dark
    if (typeof window !== 'undefined') {
      return localStorage.getItem('sdw-theme') || 'dark';
    }
    return 'dark';
  });

  useEffect(() => {
    // Apply data-theme attribute to <html> so CSS vars cascade everywhere
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('sdw-theme', theme);
  }, [theme]);

  const toggleTheme = () =>
    setTheme(prev => (prev === 'dark' ? 'light' : 'dark'));

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme, isDark: theme === 'dark' }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
